import { render, staticRenderFns } from "./CardChartTreemapWithComments.vue?vue&type=template&id=32d14a1c&scoped=true&"
import script from "./CardChartTreemapWithComments.vue?vue&type=script&lang=js&"
export * from "./CardChartTreemapWithComments.vue?vue&type=script&lang=js&"
import style0 from "./CardChartTreemapWithComments.vue?vue&type=style&index=0&id=32d14a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d14a1c",
  null
  
)

export default component.exports